import React from 'react';
import { useReactModal, autoId } from '@workday/upc-common';
import { ID_SHOW_SESSION_DETAILS_BUTTON } from '../../../../autoIds';
import { SecondaryButton } from '@workday/canvas-kit-react/button';
import Modal from 'react-modal';
import { SessionDetailsEntry } from './SessionDetailsEntry';
import { useTranslation } from 'react-i18next';

export function SessionDetailSettingsRow() {
    const sessionDetailsModal = useReactModal({ modalProps: { shouldCloseOnEsc: false } });

    const { t } = useTranslation('account');

    return (
        <div className='settingsRow'>
            <h1 className='settingsRow__title'>{t('SessionDetailSettingsRow.title')}</h1>
            <div className='settingsRow__content'>
                <p>{t('SessionDetailSettingsRow.description')}</p>
                <SecondaryButton
                    {...autoId(ID_SHOW_SESSION_DETAILS_BUTTON)}
                    type='submit'
                    onClick={sessionDetailsModal.open}>
                    {t('SessionDetailSettingsRow.openModal')}
                </SecondaryButton>
                <Modal {...sessionDetailsModal.modalProps}>
                    <SessionDetailsEntry onCloseModal={sessionDetailsModal.close} />
                </Modal>
            </div>
        </div>
    );
}
